module.exports = __webpack_public_path__ + "static/media/screen1.85dff7de.png";